import React from "react";
import { IconProps } from "../index";
import { colors } from "src/assets";

const Index: React.FC<IconProps> = ({ color, size }) => {
  const localWidth = size * (18 / 18);
  const localHeight = size * (16.569 / 18);
  const localColor = color || colors.white;
  return (
    <svg width={localWidth} height={localHeight} viewBox="0 0 18 16.569">
      <path
        d="M612.213,114.553l-.388-.279c-.021-.015-2.178-1.567-4.253-3.314-2.059-1.733-4.392-3.7-4.392-7.341,0-3,2.4-5.635,5.143-5.635a5.077,5.077,0,0,1,3.83,1.539,5.064,5.064,0,0,1,3.884-1.539c2.74,0,5.143,2.633,5.143,5.635,0,3.643-2.333,5.608-4.392,7.341s-4.171,3.294-4.192,3.309ZM608.323,99.3c-2.192,0-3.83,2.282-3.83,4.322,0,3.032,2,4.712,3.924,6.337,1.517,1.277,3.079,2.449,3.785,2.969.694-.523,2.225-1.693,3.74-2.969,1.929-1.625,3.924-3.3,3.924-6.337,0-2.04-1.638-4.322-3.83-4.322a3.8,3.8,0,0,0-3.331,1.6l-.487.652-.534-.614A4,4,0,0,0,608.323,99.3Z"
        transform="translate(-603.18 -97.984)"
        fill={localColor}
      />
    </svg>
  );
};

export default Index;
